import { newBlockContent } from '../../../Block';
import { newSmallStepContent } from '../../../SmallStep';

const Block = newBlockContent({
  block: 'MassAndCapacity',
  field: 'Measurement',
  weeks: [10, 12],
  smallSteps: [
    // Step 1
    newSmallStepContent({
      smallStep: 'UseScales',
      questionTypes: ['aII', 'aIJ', 'aIK', 'aIL', 'aIM', 'aIN'],
      archivedQuestionTypes: [],
      module: () =>
        import(
          /* webpackChunkName: "Year3/Spring/MassAndCapacity/1UseScales" */ './1UseScalesModels'
        )
    }),
    // Step 2
    newSmallStepContent({
      smallStep: 'MeasureMassInGrams',
      questionTypes: ['aIO', 'aIP', 'aIQ', 'aIR', 'aIS', 'aIT'],
      archivedQuestionTypes: [],
      module: () =>
        import(
          /* webpackChunkName: "Year3/Spring/MassAndCapacity/2MeasureMassInGrams" */ './2MeasureMassInGramsModels'
        )
    }),
    // Step 3
    newSmallStepContent({
      smallStep: 'MeasureMassInKilogramsAndGrams',
      questionTypes: ['aIU', 'aIV', 'aIW', 'aIX', 'aIY', 'aIZ2'],
      archivedQuestionTypes: ['aIZ'],
      module: () =>
        import(
          /* webpackChunkName: "Year3/Spring/MassAndCapacity/3MeasureMassInKilogramsAndGrams" */ './3MeasureMassInKilogramsAndGramsModels'
        )
    }),
    // Step 4
    newSmallStepContent({
      smallStep: 'EquivalentMassesKilogramsAndGrams',
      questionTypes: ['aI0', 'aI12', 'aI22', 'aI3', 'aI4', 'aI5'],
      archivedQuestionTypes: ['aI1', 'aI2'],
      module: () =>
        import(
          /* webpackChunkName: "Year3/Spring/MassAndCapacity/4EquivalentMassesKilogramsAndGrams" */ './4EquivalentMassesKilogramsAndGramsModels'
        )
    }),
    // Step 5
    newSmallStepContent({
      smallStep: 'CompareMass',
      questionTypes: ['aI6', 'aI7', 'aI8', 'aI92', 'aJa2', 'aJb'],
      archivedQuestionTypes: ['aI9', 'aJa'],
      module: () =>
        import(
          /* webpackChunkName: "Year3/Spring/MassAndCapacity/5CompareMass" */ './5CompareMassModels'
        )
    }),
    // Step 6
    newSmallStepContent({
      smallStep: 'AddAndSubtractMass',
      questionTypes: ['aJc2', 'aJd2', 'aJe2', 'aJf', 'aJg', 'aJh2'],
      archivedQuestionTypes: ['aJc', 'aJd', 'aJe', 'aJh'],
      module: () =>
        import(
          /* webpackChunkName: "Year3/Spring/MassAndCapacity/6AddAndSubtractMass" */ './6AddAndSubtractMassModels'
        )
    }),
    // Step 7
    newSmallStepContent({
      smallStep: 'MeasureCapacityAndVolumeInMillilitres',
      questionTypes: ['aJi', 'aJj2', 'aJk', 'aJl', 'aJm', 'aJn3'],
      archivedQuestionTypes: ['aJj', 'aJn', 'aJn2'],
      module: () =>
        import(
          /* webpackChunkName: "Year3/Spring/MassAndCapacity/7MeasureCapacityAndVolumeInMillilitres" */ './7MeasureCapacityAndVolumeInMillilitresModels'
        )
    }),
    // Step 8
    newSmallStepContent({
      smallStep: 'MeasureCapacityAndVolumeInLitresAndMillilitres',
      questionTypes: ['aJo2', 'aJp', 'aJq', 'aJr', 'aJs', 'aJt'],
      archivedQuestionTypes: ['aJo'],
      module: () =>
        import(
          /* webpackChunkName: "Year3/Spring/MassAndCapacity/8MeasureCapacityAndVolumeInLitresAndMillilitres" */ './8MeasureCapacityAndVolumeInLitresAndMillilitresModels'
        )
    }),
    // Step 9
    newSmallStepContent({
      smallStep: 'EquivalentCapacitiesAndVolumesLitresAndMillilitres',
      questionTypes: ['aJu2', 'aJv', 'aJw', 'aJx', 'aJy2', 'aJz2'],
      archivedQuestionTypes: ['aJu', 'aJy', 'aJz'],
      module: () =>
        import(
          /* webpackChunkName: "Year3/Spring/MassAndCapacity/9EquivalentCapacitiesAndVolumesLitresAndMillilitres" */ './9EquivalentCapacitiesAndVolumesLitresAndMillilitresModels'
        )
    }),
    // Step 10
    newSmallStepContent({
      smallStep: 'CompareCapacityAndVolume',
      questionTypes: ['aJA', 'aJB2', 'aJC', 'aJD', 'aJE', 'aJF'],
      archivedQuestionTypes: ['aJB'],
      module: () =>
        import(
          /* webpackChunkName: "Year3/Spring/MassAndCapacity/10CompareCapacityAndVolume" */ './10CompareCapacityAndVolumeModels'
        )
    }),
    // Step 11
    newSmallStepContent({
      smallStep: 'AddAndSubtractCapacityAndVolume',
      questionTypes: ['aJG', 'aJH', 'aJI', 'aJJ2', 'aJK', 'aJL2'],
      archivedQuestionTypes: ['aJJ', 'aJL'],
      module: () =>
        import(
          /* webpackChunkName: "Year3/Spring/MassAndCapacity/11AddAndSubtractCapacityAndVolume" */ './11AddAndSubtractCapacityAndVolumeModels'
        )
    })
  ]
});
export default Block;
